var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = (_vm.info.amount / 100).toFixed(2)
  var l0 = _vm.__map(_vm.info.memberRidesResponseList, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var g1 = !item.rideEndTime ? item.rideStartTime.substring(5, 10) : null
    var g2 = !item.rideEndTime ? item.rideStartTime.substring(11, 16) : null
    var g3 = !!item.rideEndTime ? item.rideStartTime.substring(5, 10) : null
    var g4 = !!item.rideEndTime ? item.rideStartTime.substring(11, 16) : null
    var g5 = !!item.rideEndTime ? item.rideEndTime.substring(11, 16) : null
    return {
      $orig: $orig,
      g1: g1,
      g2: g2,
      g3: g3,
      g4: g4,
      g5: g5,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }